import 'react-app-polyfill/ie9'
import 'core-js/features/array/from'
import 'core-js/features/array/find'
import 'core-js/features/array/includes'
import 'core-js/features/map'
import 'core-js/features/set'
import 'core-js/features/string/includes'
import 'core-js/features/string/starts-with'
